<template>
    <div class="altura-componente-container pa-5">
        <div class="container-agenda">
            <v-card color="white" class="container-calendario-agenda" flat>
                <v-sheet tile height="auto" class="d-flex flex-wrap container-comandos-agenda pa-2" elevation="1">
                    <v-btn rounded depressed color="primary" class="btn-agenda-hoje mb-2" @click="resetarData">
                        Hoje
                    </v-btn>
                    <div class="d-flex mb-2">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn rounded depressed color="primary" v-on="on" class="mr-2"
                                       @click="abrirModalAdicionarEvento">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            Adicionar evento
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" rounded depressed color="primary" class="mr-2"
                                       @click="abrirModalSelecionarDentista">
                                    <v-icon>mdi-tooth</v-icon>
                                </v-btn>
                            </template>
                            Filtrar dentista
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" rounded depressed color="primary"
                                       @click="abrirModalSelecionarPaciente">
                                    <v-icon>people</v-icon>
                                </v-btn>
                            </template>
                            Filtrar paciente
                        </v-tooltip>
                    </div>
                </v-sheet>
                <v-sheet tile height="65" class="d-flex mb-3"
                         v-if="dentistaFiltroSelecionado.id || pacienteFiltroSelecionado.id">
                    <CardDentistaSelecionado
                        v-if="dentistaFiltroSelecionado.id"
                        :dentista-selecionado="dentistaFiltroSelecionado"
                        @removerFiltroDentista="removerFiltroDentista"
                        class="mr-5"
                    />
                    <CardPacienteSelecionado
                        v-if="pacienteFiltroSelecionado.id"
                        :paciente-selecionado="pacienteFiltroSelecionado"
                        @removerFiltroPaciente="removerFiltroPaciente"
                    />
                </v-sheet>
                <v-sheet tile height="auto" class="d-flex flex-wrap align-center pa-2 grey lighten-5">
                    <v-btn icon @click="$refs.calendar.prev()">
                        <v-icon color="primary">mdi-chevron-left</v-icon>
                    </v-btn>
                    <div class="descricao-data-selecionada">
                        <label class="text-h6 font-weight-medium primary--text text-capitalize">{{
                                descricaoDataSelecionada
                            }}</label>
                    </div>
                    <v-btn icon @click="$refs.calendar.next()">
                        <v-icon color="primary">mdi-chevron-right</v-icon>
                    </v-btn>
                    <div class="d-flex flex-wrap flex-grow-1 flex-sm-grow-0">
                        <v-select
                            v-model="tipoVisualizacao"
                            :items="tiposVisualizacaoList"
                            item-text="nome"
                            item-value="valor"
                            dense
                            outlined
                            hide-details
                            class="ma-1 select-tipo-visualizacao"
                            label="Modo de visualização"
                        ></v-select>
                        <v-select
                            v-model="modoSobreposicao"
                            :items="modosSobreposicaoList"
                            item-text="nome"
                            item-value="valor"
                            dense
                            outlined
                            hide-details
                            label="Modo de sobreposição"
                            class="ma-1 select-modo-sobreposicao"
                        ></v-select>
                        <v-select
                            v-model="diasDaSemana"
                            :items="diasDaSemanaList"
                            item-text="nome"
                            item-value="valor"
                            dense
                            outlined
                            hide-details
                            label="Dias da semana"
                            class="ma-1 select-dias-semana"
                        ></v-select>
                    </div>
                </v-sheet>
                <v-sheet :height="$vuetify.breakpoint.xsOnly ? 400 : 600">
                    <v-calendar
                        ref="calendar"
                        v-model="valorCalendario"
                        :weekdays="diasDaSemana"
                        :type="tipoVisualizacao"
                        :events="eventosList"
                        :event-overlap-mode="modoSobreposicao"
                        :event-overlap-threshold="30"
                        event-color="color"
                        event-name="titulo"
                        event-start="start"
                        event-end="end"
                        :event-more="true"
                        :short-weekdays="$vuetify.breakpoint.xsOnly"
                        @change="getEvents"
                        @click:more="event => abrirModalMaisEventos(event)"
                        @click:event="event => abrirEventoSelecionado(event)"
                        @click:date="abrirModalAdicionarEvento"
                    >
                    </v-calendar>
                </v-sheet>
            </v-card>
            <v-card color="white" class="container-menu-lateral-dentistas" flat>
                <v-row justify="center" class="pt-2">
                    <v-date-picker
                        v-model="valorCalendario"
                        color="primary"
                        width="260"
                    />
                </v-row>

                <v-toolbar color="transparent" flat class="mt-4">
                    <h4 class="black--text">Dentistas</h4>
                </v-toolbar>
                <v-list class="mt-n6 container-list-dentistas" color="transparent" dense>
                    <div class="container-lista-vazia-dentista" v-if="dentistaList.length === 0">
                        <span>Não há dentista cadastrado!</span>
                    </div>
                    <v-list-item v-else v-for="dentista in dentistaList" :key="dentista.id"
                                 class="container-item-dentista"
                                 @click="abrirModalDentistaSelecionado(dentista)">
                        <v-list-item-avatar tile>
                            <foto-avatar :foto-url="dentista.foto" class-avatar="imagem-dentista"/>
                        </v-list-item-avatar>
                        <v-list-item-content class="container-item-dentista-content">
                            <span class="black--text">{{ dentista.nome }}</span>
                            <div class="container-sub-item-dentista">
                                <label class="grey--text">{{ dentista.cargo }}</label>
                                <div class="dentista-quadrado-cor"
                                     :style="`--cor-dentista: ${dentista.corIdentificacao}`"/>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </div>
        <v-row justify="center" class="pt-2">
            <ModalMaisEventos
                v-if="modalExibirMaisEventos"
                v-model="modalExibirMaisEventos"
                :data-selecionada="maisEventosData"
                @modalMaisEventosAcaoFechar="fecharModalMaisEventos"
            />
            <ModalEventoAgenda
                v-if="modalEventoSelecionado"
                v-model="modalEventoSelecionado"
                :evento="eventoSelecionado"
                @modalEventoAcaoFechar="fecharModalEventoSelecionado"
                @modalEventoAcaoFecharAposAtualizar="fecharModalEventoAposAtualizacao"
            />
            <ModalDentistaAgenda
                v-if="modalDentistaAgenda"
                v-model="modalDentistaAgenda"
                :dentista="dentistaAgendaSelecionado"
                @modalDentistaAcaoFechar="fecharModalDentistaSelecionado"
                @buscarListaDentistas="atualizarListaDentistasPosAlteracao"
            />
            <ModalAdicionarEventoAgenda
                v-if="modalAdicionarEvento"
                v-model="modalAdicionarEvento"
                :data-inicio="moment(valorCalendario).hour(moment().hour()).format('YYYY-MM-DD HH:mm')"
                persistencia
                @modalAdicionarEventoAcaoFechar="fecharModalAdicionarEvento"
            />
            <PesquisaPacienteModal
                v-if="modalSelecionarPaciente"
                v-model="modalSelecionarPaciente"
                @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
                @confirmarPacienteSelecionado="selecionarPaciente"
            />
            <PesquisaDentistaModal
                v-if="modalSelecionarDentista"
                v-model="modalSelecionarDentista"
                @fecharModalPesquisaDentista="fecharModalSelecionarDentista"
                @confirmarDentistaSelecionado="selecionarDentista"
            />
        </v-row>
    </div>
</template>

<script>
import moment from 'moment'
import {actionTypes} from '@/core/constants'
import ModalEventoAgenda from '@/views/pages/agenda/ModalEventoAgenda.vue'
import ModalDentistaAgenda from '@/views/pages/agenda/ModalDentistaAgenda.vue'
import ModalAdicionarEventoAgenda from '@/views/pages/agenda/ModalAdicionarEventoAgenda.vue'
import FotoAvatar from '@/views/components/FotoAvatar.vue'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import PesquisaDentistaModal from '@/views/modais/PesquisaDentistaModal.vue'
import CardDentistaSelecionado from '@/views/pages/agenda/CardDentistaSelecionado.vue'
import CardPacienteSelecionado from '@/views/pages/agenda/CardPacienteSelecionado.vue'
import ModalMaisEventos from '@/views/pages/agenda/ModalMaisEventos.vue'

export default {
    name: 'Agenda',
    components: {
        ModalMaisEventos,
        CardPacienteSelecionado,
        CardDentistaSelecionado,
        PesquisaDentistaModal,
        PesquisaPacienteModal,
        ModalAdicionarEventoAgenda, FotoAvatar, ModalDentistaAgenda, ModalEventoAgenda
    },
    data() {
        return {
            moment,
            tipoVisualizacao: 'month',
            tiposVisualizacaoList: [{nome: 'mês', valor: 'month'}, {nome: 'semana', valor: 'week'}, {
                nome: 'dia',
                valor: 'day'
            }, {nome: 'quatro dias', valor: '4day'}],
            modoSobreposicao: 'stack',
            modosSobreposicaoList: [{nome: 'pilha', valor: 'stack'}, {nome: 'coluna', valor: 'column'}],
            diasDaSemana: [0, 1, 2, 3, 4, 5, 6],
            diasDaSemanaList: [
                {nome: 'Domingo - Sábado', valor: [0, 1, 2, 3, 4, 5, 6]},
                {nome: 'Segunda-feira - Domingo', valor: [1, 2, 3, 4, 5, 6, 0]},
                {nome: 'Segunda-feira - Sexta-feira', valor: [1, 2, 3, 4, 5]},
            ],
            valorCalendario: moment().format('YYYY-MM-DD'),
            startTime: null,
            endTime: null,
            eventoSelecionado: null,
            modalEventoSelecionado: false,
            modalDentistaAgenda: false,
            dentistaAgendaSelecionado: null,
            modalAdicionarEvento: false,
            eventosList: [],
            dentistaList: [],
            pacienteFiltroSelecionado: {id: null},
            dentistaFiltroSelecionado: {id: null},
            modalSelecionarPaciente: false,
            modalSelecionarDentista: false,
            modalExibirMaisEventos: false,
            maisEventosData: null,
        }
    },
    computed: {
        descricaoDataSelecionada() {
            return moment(this.valorCalendario).locale('pt-br').format('MMMM YYYY')
        }
    },
    async mounted() {
        await this.buscarDentistas()
    },
    methods: {
        async buscarDentistas() {
            const resposta = await this.$store.dispatch(actionTypes.AGENDA.BUSCAR_DENTISTAS)
            if (resposta) {
                this.dentistaList = resposta.items
            }
        },
        async buscarEventos(startDateTime, endDateTime) {

            const input = {
                dentistaId: {value: this.dentistaFiltroSelecionado.id},
                pacienteId: {value: this.pacienteFiltroSelecionado.id},
                modoVisualizacao: {value: this.tipoVisualizacao},
                dataInicio: {value: startDateTime},
                dataFim: {value: endDateTime},
            }
            const resposta = await this.$store.dispatch(actionTypes.AGENDA.BUSCAR_EVENTOS, input)
            if (resposta) {
                this.eventosList = resposta.items
                this.startTime = startDateTime
                this.endTime = endDateTime
            }
        },
        async atualizarBuscaEventos() {
            const min = moment(this.valorCalendario).clone().startOf('month').format('YYYY-MM-DD HH:mm:ss')
            const max = moment(this.valorCalendario).clone().endOf('month').format('YYYY-MM-DD HH:mm:ss')
            await this.buscarEventos(min, max)
        },
        abrirModalAdicionarEvento() {
            this.modalAdicionarEvento = true
        },
        async fecharModalAdicionarEvento() {
            this.modalAdicionarEvento = false
            await this.atualizarBuscaEventos()
        },
        resetarData() {
            this.valorCalendario = moment().format('YYYY-MM-DD')
        },
        async getEvents({start, end}) {
            const min = moment(start.date).clone().startOf('month').format('YYYY-MM-DD HH:mm:ss')
            const max = moment(end.date).clone().endOf('month').format('YYYY-MM-DD HH:mm:ss')
            if (min === this.startTime && max === this.endTime) return
            await this.buscarEventos(min, max)
        },
        abrirEventoSelecionado(evento) {
            this.eventoSelecionado = evento.event
            this.modalEventoSelecionado = true
        },
        fecharModalEventoSelecionado() {
            this.eventoSelecionado = null
            this.modalEventoSelecionado = false
        },
        async fecharModalEventoAposAtualizacao() {
            this.fecharModalEventoSelecionado()
            await this.atualizarBuscaEventos()
        },
        abrirModalDentistaSelecionado(dentista) {
            this.dentistaAgendaSelecionado = dentista
            this.modalDentistaAgenda = true
        },
        async fecharModalDentistaSelecionado() {
            this.dentistaAgendaSelecionado = null
            this.modalDentistaAgenda = false
            await this.atualizarBuscaEventos()
        },
        async atualizarListaDentistasPosAlteracao() {
            this.fecharModalDentistaSelecionado()
            await this.buscarDentistas()
        },
        abrirModalSelecionarPaciente() {
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente() {
            this.modalSelecionarPaciente = false
        },
        async selecionarPaciente(paciente) {
            this.pacienteFiltroSelecionado = paciente
            this.fecharModalSelecionarPaciente()
            await this.atualizarBuscaEventos()
        },
        abrirModalSelecionarDentista() {
            this.modalSelecionarDentista = true
        },
        fecharModalSelecionarDentista() {
            this.modalSelecionarDentista = false
        },
        async selecionarDentista(dentista) {
            this.dentistaFiltroSelecionado = dentista
            this.fecharModalSelecionarDentista()
            await this.atualizarBuscaEventos()
        },
        async removerFiltroPaciente() {
            this.pacienteFiltroSelecionado = {id: null}
            await this.atualizarBuscaEventos()
        },
        async removerFiltroDentista() {
            this.dentistaFiltroSelecionado = {id: null}
            await this.atualizarBuscaEventos()
        },
        async abrirModalMaisEventos(evento) {
            this.maisEventosData = evento.date
            this.modalExibirMaisEventos = true
        },
        async fecharModalMaisEventos() {
            this.modalExibirMaisEventos = false
            this.maisEventosData = null
            await this.atualizarBuscaEventos()
        }
    },
}
</script>

<style scoped lang="stylus">

.container-agenda
    display flex
    flex-direction row
    justify-content space-between
    gap 20px

.btn-agenda-hoje
    text-transform none
    margin-right 20px
    font-weight bold

.container-calendario-agenda
    width 80%
    border-radius 12px !important
    overflow hidden
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08) !important

.container-list-dentistas
    max-height 400px
    overflow-y auto
    padding-right 5px

.container-item-dentista
    margin-bottom 8px
    border-radius 8px !important
    transition background-color 0.2s

.container-item-dentista:hover
    cursor pointer
    background-color #f5f5f5

.container-menu-lateral-dentistas
    width 280px
    padding 10px
    border-radius 12px !important
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.05) !important

.container-lista-vazia-dentista
    padding 20px
    font-weight 600
    color #666
    text-align center

.descricao-data-selecionada
    display flex
    align-items center
    padding 20px

    label
        color var(--theme-primary)
        font-weight bold

.container-item-dentista-content
    span
        font-size 16px

    label
        font-size 14px

.container-sub-item-dentista
    display flex

.dentista-quadrado-cor
    margin-left 5px
    border-radius 10px
    height 15px
    width 15px
    background-color var(--cor-dentista)

.imagem-dentista
    border-radius 50%
    border 2px solid #eee

@media (max-width 720px)
    .container-agenda
        display block

    .container-calendario-agenda
        width auto

    .descricao-data-selecionada
        padding 5px
        font-size 14px

    .select-tipo-visualizacao, .select-modo-sobreposicao, .select-dias-semana
        width 100%
        max-width none
        margin-bottom 10px

    .container-menu-lateral-dentistas
        margin-top 20px

    .btn-agenda-hoje
        margin-right 10px

</style>